import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Container, Jumbo, tokens } from '@treams/treams-ui';

import DepartmentsSection from './DepartmentsSection';
import EmployeesSection from './EmployeesSection';
import JobTitlesSection from './JobTitlesSection';

const Background = styled(Box)`
	min-height: 100vh;
	background: ${tokens.surface.secondary};
`;

export default function ConnectorMigrationTool() {
	const { t } = useTranslation();
	const { connectorId } = useParams<{ connectorId: string }>();

	return (
		<>
			<Jumbo
				title={t('connectors.settings.migration.pageTitle')}
				description={t('connectors.settings.migration.pageDescription')}
				backButtonLink={`/settings/integrations/${connectorId}`}
			/>
			<Background>
				<Container py={4}>
					<Flex flexDirection="column" style={{ gap: 12 }}>
						<EmployeesSection />
						<DepartmentsSection />
						<JobTitlesSection />
					</Flex>
				</Container>
			</Background>
		</>
	);
}
